import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  customsStatusErrorTitle: {
    description: 'customsEpics.customsStatusErrorTitle',
    defaultMessage: 'Customs Forms Error',
    id: 'oPr5mx',
  },
  customsStatusErrorMessage: {
    description: 'customsEpics.customsStatusErrorMessage',
    defaultMessage: 'Customs Forms could not be printed at this time. Please try again.',
    id: 'smKezF',
  },
});
